import { ModaSofa } from '@dora/backpack';
import * as O from 'fp-ts/Option';
import {
    leftArmInterstitialPosition,
    middleArmInterstitialPositions,
    rightArmInterstitialPosition,
} from '../../sofaArmInterstitialPositions';

/**
 * calculate the positions interstitial pieces should be based on the arm and size of the sofa
 */
export function interstitialPlacements(
    armInterstitials: {
        left: number;
        right: number;
        middle: number;
    },
    size: ModaSofa.Size.Size,
) {
    // generate the positions of the desired interstitials
    const placements = [];

    const leftArmPos = O.toNullable(leftArmInterstitialPosition(size));
    const middleArmPos = middleArmInterstitialPositions(size, armInterstitials.middle);
    const rightArmPos = O.toNullable(rightArmInterstitialPosition(size));

    armInterstitials.left > 0 && leftArmPos !== null && placements.push(leftArmPos);
    armInterstitials.middle > 0 && placements.push(...middleArmPos);
    armInterstitials.right > 0 && rightArmPos !== null && placements.push(rightArmPos);

    return placements;
}
